interface Props {
  character?: wowaudit.Character
}

const GearSummary = ({ character }: Props) => {
  if (!character?.details || !character?.refreshedAt) return null

  const liStyles = 'bg-card-nested border my-1 py-1 px-2 rounded-md'
  const { details } = character

  const enchantsMissing = details.gearStatus.enchants_missing ?? 0
  const emptySockets = details.gearStatus.empty_sockets ?? 0
  const jewelrySockets = details.gearStatus.jewelry_sockets_missing ?? 0
  const tierItems = details.tierItemsEquipped ?? 0
  const embellishments = details.gearStatus.embellishments ?? 0

  return (
    <ul>
      <li className={liStyles}>
        <strong>{details.currentItemLevel}</strong> equipped item level (max{' '}
        <strong>{details.maxItemLevel}</strong>)
      </li>

      <li className={liStyles}>
        <strong
          className={
            enchantsMissing > 0
              ? 'text-destructive-foreground'
              : 'text-success-foreground'
          }
        >
          {enchantsMissing}
        </strong>{' '}
        enchant{enchantsMissing === 1 ? '' : 's'} missing
      </li>

      <li className={liStyles}>
        <strong
          className={
            emptySockets !== 0
              ? 'text-destructive-foreground'
              : 'text-success-foreground'
          }
        >
          {emptySockets}
        </strong>{' '}
        empty socket{emptySockets === 1 ? '' : 's'}
      </li>

      <li className={liStyles}>
        <strong
          className={
            jewelrySockets !== 0
              ? 'text-destructive-foreground'
              : 'text-success-foreground'
          }
        >
          {jewelrySockets}
        </strong>{' '}
        jewelry socket{jewelrySockets === 1 ? '' : 's'} missing
      </li>

      <li className={liStyles}>
        <strong
          className={
            tierItems >= 4
              ? 'text-success-foreground'
              : 'text-warning-foreground'
          }
        >
          {tierItems} / 5
        </strong>{' '}
        tier items obtained
      </li>

      <li className={liStyles}>
        <strong
          className={
            embellishments === 2
              ? 'text-success-foreground'
              : 'text-destructive-foreground'
          }
        >
          {embellishments}
        </strong>{' '}
        embellishment{embellishments === 1 ? '' : 's'} equipped
      </li>
    </ul>
  )
}

export default GearSummary
